import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { BarChart2, TrendingUp, Download } from '../../lib/lucide-proxy';
import Button from '../../components/ui/Button';
import LoadingSpinner from '../../components/ui/LoadingSpinner';

const Reports = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simula um carregamento rápido para evitar o "flash" e garantir que o componente montou
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Relatórios - Cerveja Delivery</title>
      </Helmet>

      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-bold text-dark-900">Relatórios e Analytics</h2>
          <Button variant="outline" className="flex items-center gap-2">
            <Download className="w-4 h-4" /> Exportar Dados
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-sm font-medium text-dark-500">Vendas Totais</h3>
              <BarChart2 className="w-5 h-5 text-primary-500" />
            </div>
            <p className="text-2xl font-bold text-dark-900">R$ 0,00</p>
          </div>
          
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-sm font-medium text-dark-500">Ticket Médio</h3>
              <TrendingUp className="w-5 h-5 text-green-500" />
            </div>
            <p className="text-2xl font-bold text-dark-900">R$ 0,00</p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-12 text-center">
          <div className="max-w-md mx-auto">
            <BarChart2 className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-bold text-dark-900 mb-2">Relatórios Avançados</h3>
            <p className="text-dark-500">
              Gráficos detalhados de vendas, produtos mais vendidos e retenção de clientes estarão disponíveis aqui assim que as primeiras vendas forem processadas.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reports;